import { formatXOF } from "@/lib/format";

export interface CartTotalsProps {
  subtotalMinor: number;
  discountMinor: number;
  /** `null` = pas encore connu (« calculée à l'étape suivante »). */
  shippingMinor: number | null;
  totalMinor: number;
  shippingLabel?: string;
}

/**
 * Bloc de totaux partagé par le panier (§7.2) et le récapitulatif du tunnel
 * (§8.1). Porté à l'identique depuis apps/web/components/cart/CartTotals.tsx
 * (aucune dépendance Next.js dans l'original).
 */
export function CartTotals({ subtotalMinor, discountMinor, shippingMinor, totalMinor, shippingLabel }: CartTotalsProps) {
  return (
    <dl className="flex flex-col gap-2 text-sm">
      <div className="flex items-center justify-between">
        <dt className="text-muted">Sous-total</dt>
        <dd className="text-ink">{formatXOF(subtotalMinor)}</dd>
      </div>

      {discountMinor > 0 ? (
        <div className="flex items-center justify-between">
          <dt className="text-muted">Remise</dt>
          <dd className="text-ink">−{formatXOF(discountMinor)}</dd>
        </div>
      ) : null}

      <div className="flex items-center justify-between">
        <dt className="text-muted">Livraison</dt>
        <dd className="text-ink">
          {shippingLabel ? (
            <span className="font-medium text-gold">{shippingLabel}</span>
          ) : shippingMinor === null ? (
            <span className="text-muted">Calculée à l&apos;étape suivante</span>
          ) : shippingMinor === 0 ? (
            "Offerte"
          ) : (
            formatXOF(shippingMinor)
          )}
        </dd>
      </div>

      <div className="mt-1 flex items-center justify-between border-t border-line pt-2 text-base font-semibold text-ink">
        <dt>Total</dt>
        <dd>{formatXOF(totalMinor)}</dd>
      </div>
    </dl>
  );
}
